import { MouseEvent, MouseEventHandler } from "react";
import { SwipeableHandlers } from "react-swipeable";
import FixaSSRIcon from "../../../shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import TrashCanIconPath from "../../../shared/wrappers/FixaSSRIcon/paths/TrashCanIconPath";
import ProductSearchCss from "../../pages/product-search-page/product-search.module.css";
import { FixaListViewItem } from "../../../shared/wrappers/FixaListView/FixaListViewItem";

interface ProductSearchHistoryItemPresentationProps {
  handlers: SwipeableHandlers;
  onDelete: (e: MouseEvent) => void;
  showDelete: boolean;
  historyItem: string;
  onClick: () => void;
  onMouseDown?: MouseEventHandler<HTMLDivElement> | undefined;
}

export const ProductSearchHistoryItemPresentation = ({
  handlers,
  onDelete,
  showDelete,
  historyItem,
  onClick,
  onMouseDown,
}: ProductSearchHistoryItemPresentationProps) => {
  return (
    <div
      className={ProductSearchCss["swipeable-history-item"]}
      {...handlers}
      onClick={() => {
        if (!showDelete) {
          onClick();
        }
      }}
      onMouseDown={onMouseDown}
    >
      <button
        className={`${ProductSearchCss["button-delete"]} ${
          showDelete
            ? ProductSearchCss["button-delete-visible"]
            : ProductSearchCss["button-delete-invisible"]
        }`}
        onClick={onDelete}
      >
        <FixaSSRIcon paths={TrashCanIconPath} />
      </button>
      <div
        className={
          showDelete
            ? ProductSearchCss["swipe-left"]
            : ProductSearchCss["swipe-none"]
        }
      >
        <FixaListViewItem title={historyItem} size="small" inset />
      </div>
    </div>
  );
};
